/* globals analytics_data */ 
import { analyticsEvent } from './analytics-controller';
(function ($) {
	function bookmarkController() {

		this.toggle = function(e, callback) {
			callback = typeof callback === 'function' ? callback : function() {};

			var bookmark = {
				elm: $(e)
			};

			// ID of the article we're bookmarking or un-bookmarking
			bookmark.id = bookmark.elm.closest('.js-bookmark-article').data('bookmark-id');
			
			// passing SalesforceID
			bookmark.salesforceId = bookmark.elm.closest('.js-bookmark-article').attr('data-salesforce-id') || '';

			// Store label data
			bookmark.label = {
				elm: bookmark.elm.find('.js-bookmark-label')
			};
			bookmark.label.bookmark = bookmark.label.elm.data('label-bookmark');
			bookmark.label.bookmarked = bookmark.label.elm.data('label-bookmarked');

			// Are we bookmarking or un-bookmarking?
			bookmark.isBookmarking = bookmark.elm.attr('data-is-bookmarked') !== 'true';

			// Cache selector for reuse in flipIcon
			bookmark.item = $('[data-bookmark-id="' + bookmark.id + '"]');

			var apiEndpoint = bookmark.isBookmarking
				? '/Account/api/SavedDocumentApi/SaveItem/'
				: '/Account/api/SavedDocumentApi/RemoveItem/';
 
			if (bookmark.id) {
				window.INFORMA.Spinner.Show($('body'));

				$.ajax({
					url: apiEndpoint,
					type: 'POST',
					data: {
						DocumentID: bookmark.id,
						SalesforceID: bookmark.salesforceId,
						SavedDate: new Date().toUTCString()
					},
					context: this,
					success: function (response) {
						if (response.success) {
							
							if (bookmark.isBookmarking) {
								if (window.analytics_data && $(bookmark.elm).data('analytics')) {
									analyticsEvent($.extend(window.analytics_data, $(bookmark.elm).data('analytics')));
								}
								if ($('.personalisationhome').length) {
									bookmark.item.attr('data-salesforce-id', response.salesforceid);
								} else {
									bookmark.elm.closest('.js-bookmark-article').attr('data-salesforce-id', response.salesforceid);
								}
							} else {
								if ($('.personalisationhome').length) {
									bookmark.item.removeAttr('data-salesforce-id');
								} else {
									bookmark.elm.closest('.js-bookmark-article').removeAttr('data-salesforce-id');
								}
							}

							this.flipIcon(bookmark);
							window.INFORMA.Spinner.Hide();
							callback(true, e);
						} else if (response.redirectUrl) {
							window.location.href = response.redirectUrl;
							callback(false, e);
						}
					},
					error: function() {
						callback(false, e);
					}
				});
			}
		};

		this.flipIcon = function(bookmark) {
			const $personalisationHome = $('.personalisationhome');

			if ($('.collection__bookmark').length) {
				bookmark.elm.attr('data-is-bookmarked', bookmark.isBookmarking);
			}

			if ($personalisationHome.length) {
				if (!bookmark.elm.hasClass('js-angular-bookmark')) {
					bookmark.item.find('.article-bookmark').removeClass('is-visible');
				}

				if (bookmark.isBookmarking) {
					if (!bookmark.elm.hasClass('js-angular-bookmark')) {
						bookmark.item.find('.article-bookmark__bookmarked').addClass('is-visible');
						bookmark.item.attr('data-is-bookmarked', true);
					}
					bookmark.item.find('.js-bookmark-label').html(bookmark.label.bookmarked);
				} else {
					if (!bookmark.elm.hasClass('js-angular-bookmark')) {
						bookmark.item.find('.article-bookmark').not('.article-bookmark__bookmarked').addClass('is-visible');
						bookmark.item.attr('data-is-bookmarked', null);
					}
					bookmark.item.find('.js-bookmark-label').html(bookmark.label.bookmark);
				}
			} else {
				if (!bookmark.elm.hasClass('js-angular-bookmark')) {
					bookmark.elm.find('.article-bookmark').removeClass('is-visible');
				}

				if (bookmark.isBookmarking) {
					if (!bookmark.elm.hasClass('js-angular-bookmark')) {
						bookmark.elm.find('.article-bookmark__bookmarked').addClass('is-visible');
						bookmark.elm.attr('data-is-bookmarked', true);
					}
					bookmark.label.elm.html(bookmark.label.bookmarked);
				} else {
					if (!bookmark.elm.hasClass('js-angular-bookmark')) {
						bookmark.elm.find('.article-bookmark').not('.article-bookmark__bookmarked').addClass('is-visible');
						bookmark.elm.attr('data-is-bookmarked', null);
					}
					bookmark.label.elm.html(bookmark.label.bookmark);
				}
			}
		};
	}
	window.bookmarkController = bookmarkController;
})(Zepto);
export default bookmarkController;